import React from "react";

import CustomParser from "modules/CustomParser";
// ...

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import BreadcrumbsModule from "components/Breadcrumbs/BreadcrumbsModule";
import RecentItems from "components/Feedblocks/RecentItems";

import SectionBrowseByProducts from "pages-sections/products-root/SectionBrowseByProducts";

// import SectionServices from 'pages-sections/about/SectionServices.js';

import SkeletonWithFade from "components/Loading/SkeletonWithFade";

import { makeStyles } from "tss-react/mui";

import {
  textCenter,
  pageTitle,
  zeroPadding,
} from "../../assets/jss/nextjs-material-kit-pro";

const useStyles = makeStyles()({
  textCenter,
  zeroPadding,
  rootPageTitle: { ...pageTitle, marginTop: "25px" },
});

export default function RootProductsBody(props) {
  const {
    content,
    title,
    categories,
    pageTransition,
    categorySlug,
    breadcrumbsHierarchy,
    path,
    noTaxonomy,
  } = props;

  const { classes } = useStyles();

  const combinedLoading = pageTransition;

  const showTitle = noTaxonomy && content;

  return (
    <GridContainer justifyContent="center">
      <GridItem>
        <BreadcrumbsModule
          breadcrumbsHierarchy={breadcrumbsHierarchy}
          path={path}
          currentItem={title}
          pageTransition={pageTransition}
        />
        {(showTitle || combinedLoading) && (
          <>
            <h1 className={`${classes.rootPageTitle} ${classes.textCenter}`}>
              <SkeletonWithFade width="60%" inProp={combinedLoading}>
                {title}
              </SkeletonWithFade>
            </h1>
            <div className={classes.textCenter}>
              <SkeletonWithFade inProp={combinedLoading} count={4}>
                <CustomParser content={content} />
              </SkeletonWithFade>
            </div>
          </>
        )}
      </GridItem>
      <GridItem className={classes.zeroPadding}>
        <SectionBrowseByProducts
          showAllProductsButton={noTaxonomy}
          categories={categories}
          loading={combinedLoading}
          categorySlug={categorySlug}
          noTaxonomy={noTaxonomy}
          centerContent
          makeTitleH1={!showTitle}
        />
      </GridItem>
      <GridItem>
        <RecentItems showDivider loading={combinedLoading} />
      </GridItem>
    </GridContainer>
  );
}
